import React from "react";
import { Text, Stack, PrimaryButton } from "office-ui-fabric-react/lib";
import { mdiAlertCircleOutline, mdiLessThan } from "@mdi/js";
import Icon from "@mdi/react";
import { Card } from "@uifabric/react-cards";
import { GS } from "../../utils/Styles";
import { withRouter, RouteComponentProps } from "react-router";

export interface NoDataPageProps extends RouteComponentProps {
  title?: string;
  subTitle?: string;
}

export interface NoDataPageState {}

class NoDataPage extends React.Component<NoDataPageProps, NoDataPageState> {
  constructor(props: NoDataPageProps) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Stack horizontal horizontalAlign="center" verticalAlign="center" verticalFill={true}>
          <Stack.Item align="center">
            <Card className="padding-16" horizontal styles={{ root: { width: 415, ...GS.bgWhite, display: "flex", flexDirection: "column", justifyContent: "center" } }}>
              <Card.Item styles={{ root: { alignSelf: "center" } }}>
                <Icon path={mdiAlertCircleOutline} size="98px" color="#b92b32" />
              </Card.Item>
              <Card.Item styles={{ root: { alignSelf: "center" } }}>
                <Text variant="xLarge">{this.props.title ? this.props.title : "No Data Found"} </Text>
              </Card.Item>
              <Card.Item styles={{ root: { alignSelf: "center" } }}>
                <Text variant="small">{this.props.subTitle ? this.props.subTitle : ""} </Text>
              </Card.Item>
              <br />
              <Card.Item styles={{ root: { alignSelf: "center" } }}>
                <PrimaryButton onClick={() => this.props.history.goBack()} color="primary" aria-label="home">
                  <Icon path={mdiLessThan} size="14px" color="#ffff" /> &nbsp; Go Back
                </PrimaryButton>
              </Card.Item>
            </Card>
          </Stack.Item>
        </Stack>
      </>
    );
  }
}

export default withRouter(NoDataPage);
